module.exports = __webpack_public_path__ + "static/media/twohundredassists.55f0450b.jpg";